import { useEffect } from "react";
import { ASSETS } from "@utils/assets";

export const Favicon = () => {
  useEffect(() => {
    // Remove existing favicon links
    const existingLinks = document.querySelectorAll('link[rel*="icon"]');
    existingLinks.forEach((link) => link.remove());

    // Create and append new favicon links
    const links = [
      /* {
        rel: "icon",
        type: "image/svg+xml",
        href: ASSETS.FAVICON_SVG,
      }, */
      {
        rel: "icon",
        type: "image/x-icon",
        href: ASSETS.FAVICON_ICO,
      },
      {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: ASSETS.FAVICON_16,
      },
      {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: ASSETS.FAVICON_32,
      },
      {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: ASSETS.APPLE_TOUCH_ICON,
      },
    ];

    links.forEach((linkData) => {
      const link = document.createElement("link");
      Object.entries(linkData).forEach(([key, value]) => {
        link.setAttribute(key, value);
      });
      document.head.appendChild(link);
    });
  }, []);

  return null; // This component doesn't render anything
};
